import * as React from "react";
import RetrievableSizeCell from "data-lake/components/RetrievableSizeCell";
import { useDataLakeIcebergStreamMetrics } from "data-lake/hooks/useDataLakeIcebergMetrics";
import useStreamDataLakeEnabledStatus from "data-lake/hooks/useStreamDataLakeEnabledStatus";
export const RETRIEVABLE_STREAM_SIZE_ATTRIBUTE_ID = "retrievable_stream_size";
export const RETRIEVABLE_STREAM_SIZE_ATTRIBUTE = {
  id: RETRIEVABLE_STREAM_SIZE_ATTRIBUTE_ID,
  title: "Data Lake Size",
  sortable: false,
  filterable: false,
  hidden: false
};
const StreamRetrievableSizeCellWithStatus = ({
  streamId,
  bytes = 0,
  records = 0,
  files = 0,
  isLoadingMetrics = false
}) => {
  const { data: isDataLakeEnabled, isFetching } = useStreamDataLakeEnabledStatus(streamId);
  if (isLoadingMetrics || isFetching) {
    return /* @__PURE__ */ React.createElement("span", null, "\u2013");
  }
  if (!isDataLakeEnabled) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(RetrievableSizeCell, { bytes, records, files, isLoading: false });
};
const StreamRetrievableSizeCell = ({ streamId }) => {
  const { metricsByStreamId, isLoading } = useDataLakeIcebergStreamMetrics([streamId]);
  const metrics = metricsByStreamId.get(streamId);
  return /* @__PURE__ */ React.createElement(
    StreamRetrievableSizeCellWithStatus,
    {
      streamId,
      bytes: metrics == null ? void 0 : metrics.bytes,
      records: metrics == null ? void 0 : metrics.records,
      files: metrics == null ? void 0 : metrics.files,
      isLoadingMetrics: isLoading
    }
  );
};
export const retrievableStreamSizeColumnRenderer = {
  [RETRIEVABLE_STREAM_SIZE_ATTRIBUTE_ID]: {
    renderCell: (_value, stream) => /* @__PURE__ */ React.createElement(StreamRetrievableSizeCell, { streamId: stream.id }),
    staticWidth: "matchHeader"
  }
};
